import React, { useEffect } from "react";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";

import { APPROVAL_STATUS } from "../../system/global-enums";
import { EMPTY_STRING, SCREEN_PATH } from "../../constants/global.constants";
import BaseModal from "../../shared/components/modals/BaseModal";
import RegisterForm from "../auth-forms/register-survey/RegisterForm";
import { adminActions } from "../../redux/actions";

const BuyProperty = (props) => {
  const {
    user: { userId, approvalStatus },getAgentDetails ,agentUser
  } = props;

  const navigate = useNavigate();

  // Function to handle modal close and redirect to the 'My Listing' page
  const closeModal = () => {
    let path = "";
    if (approvalStatus !== APPROVAL_STATUS.APPROVED) {
      path = SCREEN_PATH.AGENT_PROFILE;
    } else {
      path = SCREEN_PATH.MY_LISTING;
    }

    navigate(path, { replace: true });
  };

  useEffect(() => {
    if (userId) {
      getAgentDetails(userId)
    }
  }, [userId])
  return (
    agentUser?.id && (<BaseModal size="xl" show showClose onClose={closeModal}>
      <RegisterForm
        defaultValues={{
  
            name: agentUser?.firstName || EMPTY_STRING,
            lastName: agentUser?.lastName || EMPTY_STRING,
            email: agentUser?.email || EMPTY_STRING,
            password: '********' || EMPTY_STRING,
            confirmPassword: '********' || EMPTY_STRING
          
        }}
        userId={userId} />
    </BaseModal>)
  );
};

const mapStateToProps = (state) => ({
  user: state.authReducer.user,
  agentUser: state.adminReducer.agentDetails,
});

const mapDispatchToProps = (dispatch) => ({
  getAgentDetails: (id) => dispatch(adminActions.getAgentDetails(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(BuyProperty);
